module.exports = __webpack_public_path__ + "img/spirit_light_grey_ba_detail_rsh0(1).479cfa80.jpg";